'use client';
import { useRef } from 'react';
import React from 'react';
import { ChatMessage, MessageWidget, RequestScrollCallback } from '@chewy/chat-library-common';
import { HeartBurstAnimation } from '../FloatingHearts/HeartBurstAnimation';
import { Transition3DPhase } from '../TransitionAnimation';
import styles from './TextWithHeart.module.scss';
import { useConversation } from '@chewy/chat-library-common';

export interface TextWithHeartProps {
  /** Text to display */
  data?: MessageWidget | MessageWidget[];
  /** Whether the animation is active */
  trigger?: boolean;
  /** Phase: 'initial' | 'revealing' | 'complete' */
  phase?: Transition3DPhase;
  /** Message */
  message?: ChatMessage;
  /** When true, allows transition to complete phase */
  messageState?: boolean;
  /** Custom class name */
  className?: string;
  /** Callback when animation completes */
  onComplete?: () => void;
  /** Whether the animation persists */
  persist?: boolean;
  /** Scroll callback from conversation context */
  requestScroll?: RequestScrollCallback;
}

export const TextWithHeart: React.FC<TextWithHeartProps> = ({
  className,
  onComplete,
  data,
  trigger = true,
}) => {
  const { phase: contextPhase } = useConversation();
  const usedphase = contextPhase || data?.[0]?.phase || '';
  const containerRef = useRef<HTMLDivElement>(null);

  // Extract data from the first widget if data is an array
  const widgetData = Array.isArray(data) ? data[0] : data;

  // const [phase, setPhase] = useState<TransitionPhase>(data.phase, data.setPhase);
  // Build class names based on phase and messageState
  // Only allow complete phase when messageState is true
  const containerClasses = [
    styles.container,
    usedphase === 'revealing' && styles.revealing,
    usedphase === 'complete' && styles.complete,
    className,
  ].filter(Boolean).join(' ');

  // Use data from message or fallback to pet name / default text
  const headingText = widgetData?.headingText;
  const subText = widgetData?.subText;

  return (
    <div ref={containerRef} className={containerClasses}>
      {/* Text container */}
      <div>
        {/* Heading with heart inline */}
        <div className={styles.headingRow}>
          <span className={styles.headingText}>{headingText}</span>
          <span className={styles.heartElement}>
            <HeartBurstAnimation
              width={20}
              height={120}
              trigger={trigger}
              onComplete={onComplete}
              persist={true}
            />
          </span>
        </div>

        {/* Sub text below */}
        <span className={styles.subText}>{subText}</span>
      </div>
    </div>
  );
};

export default TextWithHeart;
